export const state = (): {
  modals: string[]
} => {
  return {
    modals: [],
  }
}
